@import '../../../../../../../constants/spacing.module.less';
@import '../../../../../../../app-brand/concepts/shipstation-concept-layer-default.module.less';

.address-wrapper {
  width: 100%;
  margin-top: @space-8;
  color: var(--gray-637381);
  display: flex;
}

.warehouse-address {
  color: var(--gray-637381);
  width: 100%;
}

.address-icon {
  height: 16px;
  width: 16px;
  margin-top: 2px;
  margin-right: @space-16;
}
